"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomInContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../../../assets/styles/colors");
const ZoomInContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => (props.$isMobile ? "2.8rem" : "4.2rem")};
  height: 2.8rem;
  border-radius: 25px;
  background-color: ${colors_1.white};
  cursor: pointer;
  ${(props) => !props.$isMobile && `box - shadow: 2px 2px 4px 0px ${colors_1.gray900};`}
  z-index: 100;
`;
exports.ZoomInContainer = ZoomInContainer;
